import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Form } from 'react-bootstrap';
import { useEffect } from 'react';
const MainMenuFilter = ({ masjidTypes, wellTypes, countryAPIData, typeId, onSearch, setFilterData }) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const { t } = useTranslation();
  // const handleChange = (e) => {
  //   setFilterData((prev) => ({
  //     ...prev,
  //     [e.target.name]: e.target.value,
  //   }));
  // };

  const handleChange = (e) => {
    setFilterData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  useEffect(() => {
    setFilterData({
      countryId: '',
      masjidTypeId: '',
      wellTypeId: '',
    });
  }, [setFilterData]);
  return (
    <>
      <div className={`row  sm:mx-auto ${isActive ? 'lg:mr-[200px]' : 'lg:ml-[200px]'} `}>
        <div className={`flex gap-x-4 ${typeId == 1 || typeId == 3 ? 'col-lg-6' : 'col-lg-3'}`}>
          {/* Masjid Type Dropdown for typeId 1 */}
          {typeId == 1 && (
            <select
              type="text"
              onChange={(e) => handleChange(e)}
              className="form-control border rounded-lg p-2 focus:outline-none focus:ring-green-500 focus:border-green-500"
              name="masjidTypeId"
            >
              <option value="">{t('Masjid Type')}</option>
              {masjidTypes?.map((masjidType) => (
                <option key={masjidType?.id} value={masjidType?.id}>
                  {isActive ? masjidType?.type_AR : masjidType?.type_EN}
                </option>
              ))}
            </select>
          )}

          {/* Well Type Dropdown for typeId 3 */}
          {typeId == 3 && (
            <select
              type="text"
              onChange={(e) => handleChange(e)}
              className="form-control border rounded-lg p-2 focus:outline-none focus:ring-green-500 focus:border-green-500"
              name="wellTypeId"
            >
              <option value="">{t('Well Type')}</option>
              {wellTypes?.map((wellType) => (
                <option key={wellType?.id} value={wellType?.id}>
                  {isActive ? wellType?.type_AR : wellType?.type_EN}
                </option>
              ))}
            </select>
          )}

          {/* Country Dropdown (for all typeId) */}
          <select
            type="text"
            onChange={(e) => handleChange(e)}
            className="form-control border rounded-lg p-2 focus:outline-none focus:ring-green-500 focus:border-green-500 "
            name="countryId"
          >
            <option value="">{t('Country')}</option>
            {countryAPIData?.map((country) => (
              <option key={country?.id} value={country?.id}>
                {isActive ? country?.name_AR : country?.name_EN}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="flex justify-center mt-3">
        <button
          onClick={onSearch}
          className="bg-customgreen text-white rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-green-500 w-32"
        >
          {t('Search')}
        </button>
      </div>
    </>
  );
};

export default MainMenuFilter;
